export const Home = "home";
export const Users = "users";
export const Clients = "clients";
export const AccessDenied = "accessDenied";